import React from "react";
import PropTypes from "prop-types";
import Input from "./forms/Input";
import Button from "./Button";
import { gql } from "apollo-boost";
import { EMAIL_REGEX } from "../utils/validation";
import { withApollo, graphql, compose } from "react-apollo";
import { TableRow, TableCell } from "./Table";
import Icon from "./Icon";
import { ADD } from "../icons";
import Loader from "./PulseLoader";
import { addToCache } from "../utils/queryHelpers";
import { FRANCHISE_MEMBERSHIPS_QUERY } from "./FranchiseStaff";

const USER_BY_EMAIL_QUERY = gql`
  query UserByEmail($email: String!) {
    userByEmail(email: $email) {
      id
      name
      email
    }
  }
`;

const FormTableRow = TableRow.withComponent("form");
const defaultState = {
  loading: false,
  email: "",
  owner: false,
  canSubmitJobs: false,
  trackAsSalesperson: false,
  errors: {}
};

class NewFranchiseStaffRow extends React.Component {
  static propTypes = {
    columns: PropTypes.string,
    onSubmit: PropTypes.func
  };

  static defaultProps = {
    onSubmit: () => {}
  };

  state = { ...defaultState };

  fetchUser = () => {
    return this.props.client
      .query({
        query: USER_BY_EMAIL_QUERY,
        variables: { email: this.state.email }
      })
      .then(({ data }) => data.userByEmail)
      .catch(() => null);
  };

  handleSubmit = e => {
    if (e) e.preventDefault();
    const { email, owner, canSubmitJobs, trackAsSalesperson } = this.state;
    const { createFranchiseMembership, createUser } = this.props;

    this.setState({ loading: true });
    this.fetchUser()
      .then(user => {
        if (user) {
          // User already exists, just create the membership
          return createFranchiseMembership({
            input: {
              owner,
              canSubmitJobs,
              trackAsSalesperson,
              userId: user.id
            }
          });
        }

        // User doesn't exist, so we'll create them
        return createUser({
          input: { email }
        }).then(({ data: { createUser: user } }) =>
          createFranchiseMembership({
            input: {
              owner,
              canSubmitJobs,
              trackAsSalesperson,
              userId: user.id
            }
          })
        );
      })
      .then(() => {
        // We're done. Reset the state.
        this.setState({ ...defaultState });
      });
  };

  handleChange = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  handleCheckboxToggle = e => {
    this.setState({
      [e.target.name]: e.target.checked
    });
  };

  render() {
    const { email } = this.state;
    const isValid = typeof email === "string" && email.match(EMAIL_REGEX);

    return (
      <FormTableRow onSubmit={this.handleSubmit} columns={this.props.columns}>
        <TableCell>
          <Input
            name="email"
            value={this.state.email}
            hasError={this.state.email.length && !isValid}
            onChange={this.handleChange}
            placeholder="New user email"
          />
        </TableCell>
        <TableCell justify="center">
          <input
            type="checkbox"
            name="owner"
            checked={this.state.owner}
            onChange={this.handleCheckboxToggle}
          />
        </TableCell>
        <TableCell justify="center">
          <input
            type="checkbox"
            name="canSubmitJobs"
            checked={this.state.canSubmitJobs}
            onChange={this.handleCheckboxToggle}
          />
        </TableCell>
        <TableCell justify="center">
          <input
            type="checkbox"
            name="trackAsSalesperson"
            checked={this.state.trackAsSalesperson}
            onChange={this.handleCheckboxToggle}
          />
        </TableCell>
        <TableCell justify="flex-end">
          <Button
            type="submit"
            variant="primary"
            hasIcon
            disabled={!isValid || this.state.loading}
          >
            {this.state.loading ? <Loader size={6} /> : <Icon icon={ADD} />}
          </Button>
        </TableCell>
      </FormTableRow>
    );
  }
}

const CREATE_USER_MUTATION = gql`
  mutation CreateUserMutation($input: UserInput!) {
    createUser(input: $input) {
      id
      name
      phone
      email
      invitationTokenRedeemed
    }
  }
`;

const CREATE_FRANCHISE_MEMBERSHIP_MUTATION = gql`
  mutation CreateFranchiseMembership($input: FranchiseMembershipInput!) {
    createFranchiseMembership(input: $input) {
      id
      owner
      trackAsSalesperson
      canSubmitJobs
      user {
        id
        name
        email
        invitationTokenRedeemed
      }
    }
  }
`;

const enhance = compose(
  withApollo,
  graphql(CREATE_USER_MUTATION, {
    props: ({ mutate }) => ({
      createUser: ({ input }) => {
        return mutate({
          variables: { input }
        });
      }
    })
  }),
  graphql(CREATE_FRANCHISE_MEMBERSHIP_MUTATION, {
    props: ({ mutate, ownProps: { franchiseId } }) => ({
      createFranchiseMembership: ({ input }) => {
        return mutate({
          variables: {
            input: {
              ...input,
              franchiseId
            }
          },
          update: (store, { data: { createFranchiseMembership } }) => {
            addToCache(
              createFranchiseMembership,
              store,
              "franchiseMemberships",
              {
                query: FRANCHISE_MEMBERSHIPS_QUERY,
                variables: { franchiseId }
              }
            );
          }
        });
      }
    })
  })
);

export default enhance(NewFranchiseStaffRow);



// WEBPACK FOOTER //
// ./src/components/NewFranchiseStaffRow.js